<!--sidebar wrapper -->
<div class="sidebar-wrapper" data-simplebar="true" (mouseover)="over(1)" (mouseout)="over(2)">
    <div class="sidebar-header">
        <div>
            <img  loading="lazy"  src="../../../assets/images/logo_ic.png" class="logo-icon" alt="logo icon" (click)="redirect()">
        </div>
        <div>
            <img  loading="lazy"  src="../../../assets/images/inner_logo.png" class="inner-logo" alt="Inner logo" (click)="redirect()">
        </div>
        <div class="toggle-icon ms-auto" (click) = "sideIcon()">
            <i class='gricon gr_ic_bars'></i>
        </div>
    </div>
    <!--navigation-->
    <ul class="metismenu" id="menu">
        <li routerLinkActive="mm-active">
            <a routerLink="/dashboard">
                <div class="parent-icon">
                    <i class='gricon gr_ic_dashboard'></i>
                </div>
                <div class="menu-title"><span [translate]="'GREATER.DASHBOARD'"> </span></div>
            </a>
        </li>
        <li routerLinkActive="mm-active">
            <a routerLink="/singles">
                <div class="parent-icon">
                    <i class='gricon gr_ic_video'></i>
                </div>
                <div class="menu-title"><span [translate]="'GREATER.SINGLES_CONTENT'"> </span></div>
            </a>
        </li>
        <li routerLinkActive="mm-active">
            <a routerLink="/albums">
                <div class="parent-icon">
                    <i class='gricon gr_ic_video_camera'></i>
                </div>
                <div class="menu-title"><span [translate]="'GREATER.ALBUM_CONTENT'"> </span></div>
            </a>
        </li>
        <li routerLinkActive="mm-active">
            <a routerLink="/programs">
                <div class="parent-icon">
                    <i class='gricon gr_ic_programs font-20'></i>
                </div>
                <div class="menu-title"><span [translate]="'GREATER.PROGRAM_CONTENT'"> </span></div>
            </a>
        </li>
        <li routerLinkActive="mm-active">
            <a routerLink="/partners">
                <div class="parent-icon">
                    <i class='gricon gr_ic_users font-20'></i>
                </div>
                <div class="menu-title"><span [translate]="'GREATER.COLLABRATORS'"> </span></div>
            </a>
        </li>
        <li routerLinkActive="mm-active">
            <a routerLink="/followers">
                <div class="parent-icon">
                    <i class='gricon gr_ic_users'></i>
                </div>
                <div class="menu-title"><span [translate]="'GREATER.AUDIENCE'"> </span></div>
            </a>
        </li>
        <li routerLinkActive="mm-active">
            <a routerLink="/financials">
                <div class="parent-icon">
                    <i class='gricon gr_ic_dollar_fill'></i>
                </div>
                <div class="menu-title"><span [translate]="'GREATER.FINANCIALS'"> </span></div>
            </a>
        </li>
        <li routerLinkActive="mm-active">
            <a routerLink="/faq">
                <div class="parent-icon">
                    <i class='gricon gr_ic_faq_fill'></i>
                </div>
                <div class="menu-title"><span [translate]="'GREATER.FAQ'"> </span></div>
            </a>
        </li>
        <li routerLinkActive="mm-active">
            <a data-bs-toggle="modal" data-bs-target="#CONFIRMPopup">
                <div class="parent-icon">
                    <i class='gricon gr_ic_logout'></i>
                </div>
                <div class="menu-title"><span [translate]="'GREATER.LOGOUT'"> </span></div>
            </a>
        </li>
    </ul>
    <!--end navigation-->
</div>
<!--end sidebar wrapper -->

<div class="modal fade" id="CONFIRMPopup" tabindex="-1" aria-labelledby="CONFIRMPopupLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content darkthird-bg border-radius10">
            <div class="modal-body">
                <div class="verify-header pb-3 pt-4 text-center">
                    <div class="py-4">
                        <img  loading="lazy"  src="../../../assets/images/inner_logo.png">
                    </div>
                    <h6 class="title white-color m-0 py-4"> <span [translate]="'GREATER.ARE_YOU_SURE_WANT_LOGOUT'"> </span> </h6>
                    <div class="py-4 d-flex justify-content-center">
                        <a routerLink="/" (click)="service.logOut();close()" class="btn gradient1-btn custom-btn me-2"> <span [translate]="'GREATER.YES'"> </span> </a>
                        <a class="btn gradient1-btn custom-btn ms-2" (click)="close()"> <span [translate]="'GREATER.NO'"> </span> </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>